<script setup lang="ts">
import VerticalTabs from '@/core/components/layout-elements/VerticalTabs.vue';
import { JobBoard } from '@/core/collections/job-boards/job-board.interface';
import GeneralSettings from '@/apps/admin/components/settings/tabs/GeneralSettings.vue';
import FooterSettings from '@/apps/admin/components/settings/tabs/FooterSettings.vue';
import ThemeSettings from '@/apps/admin/components/settings/tabs/ThemeSettings.vue';
import HeaderSettings from '@/apps/admin/components/settings/tabs/HeaderSettings.vue';
import CategoryImageSettings from '@/apps/admin/components/settings/tabs/CategoryImageSettings.vue';
import MediaLibrarySettings from '@/apps/admin/components/settings/tabs/MediaLibrarySettings.vue';
import { useSettingsStore } from '@/apps/admin/stores/settings.store';
import { tabs, SettingsTabId } from './constants';
import SollicitantsSettings from '@/apps/admin/components/settings/tabs/SollicitantsSettings.vue';

const settingsStore = useSettingsStore();
const jobBoard = defineModel<JobBoard>('modelValue', { required: true });
</script>

<template>
   <VerticalTabs v-model="settingsStore.activeTab" :tabs="tabs">
      <GeneralSettings class="settings-form-layout" v-if="settingsStore.activeTab === SettingsTabId.General" v-model="jobBoard" />
      <FooterSettings class="settings-form-layout" v-if="settingsStore.activeTab === SettingsTabId.Footer" v-model="jobBoard" />
      <HeaderSettings class="settings-form-layout" v-if="settingsStore.activeTab === SettingsTabId.Header" v-model="jobBoard" />
      <SollicitantsSettings class="settings-form-layout" v-if="settingsStore.activeTab === SettingsTabId.Sollicitants" v-model="jobBoard" />
      <ThemeSettings class="settings-form-layout" v-if="settingsStore.activeTab === SettingsTabId.Theme" v-model="jobBoard" />
      <CategoryImageSettings v-if="settingsStore.activeTab === SettingsTabId.CategoryImages" :jobBoardId="jobBoard.id" />
      <MediaLibrarySettings v-if="settingsStore.activeTab === SettingsTabId.MediaLibrary" :jobBoardId="jobBoard.id" />
   </VerticalTabs>
</template>
